module.exports = __webpack_public_path__ + "img/man02のコピー.1be82578.svg";